import { DescripteursContexte } from '@pcscol/odf-api-v1-angular';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { ObjetMaquetteService } from '../../services/objet-maquette.service';
import { ObjetMaquette } from '../objet-maquette.model';
import { ObjetMaquetteUndoCommand } from './command';
import { CommandEvents } from './command-events';

/**
 * TODO: à revoir car modifierDescripteursContexte retourne 204
 */
export class ModifierDescripteursContexteObjetMaquetteCommand extends ObjetMaquetteUndoCommand<ObjetMaquette> {
    constructor(
        codeStructure: string,
        id: string,
        version: string,
        events: CommandEvents,
        objetMaquetteService: ObjetMaquetteService,
        private contexteId: string,
        private oldDescripteursContexte: DescripteursContexte,
        private newDescripteursContexte: DescripteursContexte
    ) {
        super(codeStructure, id, version, events, objetMaquetteService);
    }

    do(): Observable<ObjetMaquette> {
        return this.objetMaquetteService
            .modifierDescripteursContexte(this.id, this.contexteId, this.version, this.newDescripteursContexte)
            .pipe(tap(om => this.events.objetMaquetteModifie$.next(om)));
    }

    undo(): Observable<ObjetMaquette> {
        return this.objetMaquetteService
            .modifierDescripteursContexte(this.id, this.version, this.contexteId, this.oldDescripteursContexte)
            .pipe(tap(om => this.events.objetMaquetteModifie$.next(om)));
    }
}
